import { render, staticRenderFns } from "./DetailTemplate.vue?vue&type=template&id=3ed94395&scoped=true&"
import script from "./DetailTemplate.vue?vue&type=script&lang=js&"
export * from "./DetailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed94395",
  null
  
)

export default component.exports